<template>
  <div class="ele-icon-picker">
    <el-dialog
      :visible.sync="dialogVisible"
      width="70%"
      :close-on-click-modal="false"
      :append-to-body="true"
      title="选择图标"
      top="5vh"
      @close="handleClose"
    >
      <div class="icon-grid">
        <div
          class="icon-item"
          v-for="name in filteredIcons"
          :key="name"
          :class="{ active: name === current }"
          @click="selectIcon(name)"
        >
          <i :class="name" class="icon" />
          <div class="name" :title="name">{{ name }}</div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button type="primary" size="small" :disabled="!current" @click="confirm">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { iconFontList } from "./icon.js";

export default {
  name: "EleIcon",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      keyword: "",
      current: "",
      allIcons: iconFontList || [],
    };
  },
  methods: {
    // 外部调用：打开选择框，可选传入默认图标
    openDialog(defaultIcon) {
      this.current = "";
      this.dialogVisible = true;
      // 轻量防抖后的筛选
      this.onSearch();
    },
    handleClose() {
      this.keyword = "";
    },
    onSearch() {
      // 无需额外开销，computed 已处理
    },
    selectIcon(name) {
      this.current = name;
    },
    cancel() {
      this.dialogVisible = false;
    },
    confirm() {
      const value = this.current || "";
      this.dialogVisible = false;
      // 回调事件
      this.$emit("confirm", value);
    },
  },
  computed: {
    filteredIcons() {
      const kw = (this.keyword || "").trim().toLowerCase();
      if (!kw) return this.allIcons;
      return this.allIcons.filter((n) => n.toLowerCase().includes(kw));
    },
  },
};
</script>
<style lang="scss" scoped>
.icon-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  height: 70vh;
  overflow-y: auto;
  .icon-item {
    cursor: pointer;
    width: 120px;
    padding: 10px;
    border: 1px solid #ccc;
    text-align: center;
    .icon {
      font-size: 30px;
      margin-bottom: 5px;
    }
    .name {
      margin-top: 10px;
    }
  }
}
.active {
  background: #5eadff;
  color: #fff;
}
</style>
